var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.147 30",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.715.605l5.234,3.9.041.06v9.182l1.4.986L30.147,19.1v8.487L27.782,29.91H19.847l-4.672-6.769c0-.024.022.011,0,0L10.485,30H2.573L0,27.366V18.922l1-.78,6.237-4.489v8.89a1.725,1.725,0,0,1-.423.916,2.011,2.011,0,0,1,1.306-.346H22.15a2.19,2.19,0,0,1,1.217.391,1.948,1.948,0,0,1-.362-1.323l0-.072V13.773l-2.043-1.5L15.634,8.243a2.867,2.867,0,0,1-.478-.767c-.158.34-.182.568-.5.817l-7.365,5.32h-.06V4.547l2-1.5L13.47,0h3.386l.859.605Zm-1.6,1.684H14.228L9.52,5.752v3.39l5.656-4.133,5.591,4.229V5.883l-4.65-3.594Zm11.732,17.92-2.634-1.872v7.046h-5.73l1.7,2.3h5.494c.409-.39.775-.8,1.17-1.207v-6.27ZM4.95,25.365V18.211L2.284,20.228V26.56l1.133,1.184H9.036l1.74-2.378H4.95Z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudli);
export default __webpack_public_path__ + "static/media/studli.cd205109620f2c0bc2be5f29efed18dc.svg";
export { ForwardRef as ReactComponent };